import * as React from 'react';
import { useState } from 'react';
import { dispatcher } from 'lib/Dispatcher';
import Drift, { DriftAttributes } from './Drift';
import { useQuery } from '@apollo/client';
import CurrentUser from 'auth/CurrentUser';
import enumerate from 'lib/enumerate';

import { DriftTokenQuery, DriftTokenQueryVariables } from './__generated__/DriftTokenQuery';
import DRIFT_TOKEN_QUERY from './driftTokenQuery.gql';

const APP_ID = '87z8gftie3cy';

export const ActionTypes = enumerate(['JWT_SUCCESS', 'LOGOUT']);
export type DriftJWT = {
  token: string;
  expiresAt: Date;
};

type Props = {
  attributes: DriftAttributes;
};

export const getUserAttributes = () => {
  const user = CurrentUser.isSignedIn() ? CurrentUser.getUser() : undefined;

  return {
    endUser: true,
    email: user?.getEmail(),
    firstName: user?.getFirstName(),
    lastName: user?.getLastName(),
  };
};

export default function DriftBot({ attributes }: Props) {
  const [fetchingJwt, setFetchingJwt] = useState<boolean>(true);
  const [jwt, setJwt] = useState<string | null | undefined>(CurrentUser.getDriftToken());

  const variables = CurrentUser.isSignedIn() ? { userUuid: CurrentUser.getUserUuid() } : undefined;

  const { loading } = useQuery<DriftTokenQuery, DriftTokenQueryVariables>(DRIFT_TOKEN_QUERY, {
    variables,
    onCompleted: (data) => {
      if (data?.api_driftSignedIdentity?.token) {
        const token = data.api_driftSignedIdentity.token.value;
        setJwt(token);
        setFetchingJwt(false);
        dispatcher.dispatch({
          type: ActionTypes.JWT_SUCCESS,
          token,
        });
      }
    },
    onError: (_) => {
      setFetchingJwt(false);
    },
    skip: !CurrentUser.isSignedIn() || !!CurrentUser.getDriftToken(),
  });

  if (loading || fetchingJwt) return null;

  return (
    <Drift
      attributes={attributes}
      appId={APP_ID}
      token={jwt}
      driftIdentifyId={CurrentUser.getUserUuid()}
    />
  );
}
